"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRatingStars = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RatingStarsMixin = require("../../mixins/components/RatingStarsMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledRatingStars = /*#__PURE__*/(0, _styledComponents.default)('span').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['value'])
}).withConfig({
  displayName: "StyledRatingStars",
  componentId: "c11n-8-107-0__sc-ehkjiy-0"
})(["", ""], _RatingStarsMixin.RatingStarsMixin);
exports.StyledRatingStars = StyledRatingStars;